import { ProvinceConfigurationInjection } from "features/provinceConfiguration/di/ProvinceConfigurationInjection";
import { DistrictConfigurationImpl } from "../data/DistrictConfigurationImpl";
import { IDistrictConfigurationRepository } from "../domain/repositories/IDistrictConfigurationRepository";
import { DistrictConfigurationUseCase } from "../domain/useCases/DistrictConfigurationUseCase";
import { DistrictConfigurationViewModel } from "../presentation/viewModel/DistrictConfigurationViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class DistrictConfigurationInjection extends InjectionModule {
  private static readonly districtConfigurationRepositoryToken = Symbol(
    "IDistrictConfigurationRepository",
  );
  private static readonly districtConfigurationUseCaseToken = Symbol(
    "DistrictConfigurationUseCase",
  );
  private static readonly districtConfigurationViewModelToken = Symbol(
    "DistrictConfigurationViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.districtConfigurationRepositoryToken,
      useClass: DistrictConfigurationImpl,
    },
    {
      scope: "otherRepo",
      token: this.districtConfigurationUseCaseToken,
      useClass: DistrictConfigurationUseCase,
    },
    {
      scope: "viewModel",
      token: this.districtConfigurationViewModelToken,
      useClass: DistrictConfigurationViewModel,
    },
  ];

  static getRepo(): IDistrictConfigurationRepository {
    return this.resolve(this.districtConfigurationRepositoryToken);
  }

  static getUseCase(): DistrictConfigurationUseCase {
    return this.resolve(this.districtConfigurationUseCaseToken);
  }

  static override initialize(): void {
    ProvinceConfigurationInjection.initialize();
    super.initialize();
  }
}
